import React, { useEffect, useState } from "react";
import ActionModal from "../../table/ActionModal";
import { useNavigate, useParams } from "react-router-dom";
import { navToPayment, navToSplitBill } from "../../../services/order-common-service";
import FloorPlanModal from "../../modals/FloorPlanModal";
import { replaceSelectedTablesInStore, resetNewlySelectedTableInStore, setFloorPlanModalActionMode, updateGuestNumber } from "../../../utils/store-mutator.table-management";
import useTableManagementStorage from "../../../stores/useTableManamentStore";
import { getOrCreateSessionId } from "../../../utils/Common";
import { hasMissingTable, orderMergeRequest, orderTransferRequest, updateGuestsRequest } from "../../../services/order-table-base-service";
import useUserStore from "../../../stores/store";
import ApiService from "../../../utils/ApiService";
import DisplayInvoice from "../../modals/DisplayInvoiceModal";
import ConfirmModal from "../../modals/ConfirmModal";
import CustomModal from "../../modals/CustomModal";
import CustomInputNumber from "../../CustomInputNumber";

const sessionId = getOrCreateSessionId();

export default function ActionModalWrapper({ open, setIsOpenActionModal, isTakeout }) {
  const navigate = useNavigate();
  const { user, showNotification, setNetworkCall } = useUserStore();
  const { getIdWiseSelectedTables, getIdWiseSelectedTablesOrg, idWiseGuestNumber } = useTableManagementStorage();
  const { orderId } = useParams();
  const [layoutModalParams, setLayoutModalParams] = useState({
    actionType: "",
    openModal: false,
  });
  const [isOpenModalInvoice, setIsOpenModalInvoice] = useState(false);
  const [isOpenModalConfirm, setIsOpenModalConfirm] = useState(false);
  const [isOpenModalGuestsInput, setIsOpenModalGuestsInput] = useState(false);
  const [guestNo, setGuestNo] = useState("");

  const handleOrderTransfer = async () => {
    const tablesOrg = getIdWiseSelectedTablesOrg(sessionId);
    const tablesNew = getIdWiseSelectedTables(sessionId);

    if (tablesNew.length === 0) {
      showNotification("Sorry. You did not select any table.");
      return;
    }

    if (!hasMissingTable(tablesOrg, tablesNew)) {
      showNotification("Sorry. You are going to transfer order to existing table.");
      return;
    }

    const tables = tablesNew.map((item) => ({
      floorId: item.floorId,
      tableId: item.tableId,
      tableName: item.tableName,
    }));

    const orderId = tablesOrg[0].orderId;
    
    setNetworkCall(true);
    const result = await orderTransferRequest(user.token.token, showNotification, { orderId, tables });
    setNetworkCall(false);

    if (result.success) {
      setLayoutModalParams({ actionType: "", openModal: false });
      navigate("/table");
    }
  };

  const handleOrderMerge = async () => {
    const tables = getIdWiseSelectedTables(sessionId);
    let orderIds = tables.map((item) => item.orderId);
    orderIds = [...new Set(orderIds)];

    if (orderIds.length === 1) {
      showNotification("Sorry. Single order cannot be merged.");
      return;
    }

    setNetworkCall(true)

    const result = await orderMergeRequest(user.token.token, showNotification, orderIds);

    setNetworkCall(false);

    if (result.success) {
      setLayoutModalParams({ actionType: "", openModal: false });
      navToPayment(navigate, result.record.newOrderId, "TABLE");
    }
  };

  const onHandleCancelLayoutModal = (actionType) => {
    setLayoutModalParams({
      openModal: false,
      actionType: "",
    });
    resetNewlySelectedTableInStore();
  };

  const layoutModalActionHandler = async (actionType) => {
    if (actionType === "MERGE_ORDER") {
      handleOrderMerge();
      return;
    }

    if (actionType === "TRANSFER_ORDER") {
      handleOrderTransfer();
    }
  };

  const handleCancelModalInvoice = () => {
    setIsOpenModalInvoice(false);
  };

  async function onHandleDeclineOrder() {
    setNetworkCall(true);
    setIsOpenModalConfirm(false);

    let res = await ApiService.ORDER_STATUS_CHANGE({ orderId, selection: 0 }, user.token.token);

    if (res.status === "ok" && res.payload.refundInfo) {
      setNetworkCall(false);
      return;
    }

    if (res.code !== 200) {
      setNetworkCall(false);
      showNotification("Failed to decline order!");
      console.error(res.message);
      return;
    }
    showNotification("Order is successfully declined!", false);
    setNetworkCall(false);
    navigate("/table");
  }

  const onCancelGuestsInput = () => {
    setGuestNo('');
    setIsOpenModalGuestsInput(false);
  };

  const updateGuests = async () => {
    setNetworkCall(true);
    const result = await updateGuestsRequest(user.token.token, showNotification, {orderId, guests: guestNo});
    
    if (result.success) {
      updateGuestNumber(guestNo);
    }
    setNetworkCall(false);
    onCancelGuestsInput();
  };

  const handleModalButtonsAction = (actionType) => {
    setFloorPlanModalActionMode(actionType);
    console.log(">>>>>>>----handleActionModalButtonClick-------<<<<<<<<<<", { actionType });
    setIsOpenActionModal(false);

    if (actionType === "SPLIT_BILL") {
      const takeout = isTakeout ? "Yes" : "No";
      navToSplitBill(navigate, orderId, "TABLE", takeout);
      return;
    }

    if (actionType === "MERGE_ORDER") {
      setLayoutModalParams({
        openModal: true,
        actionType,
      });
      return;
    }

    if (actionType === "TRANSFER_ORDER") {
      replaceSelectedTablesInStore([]);
      setLayoutModalParams({
        openModal: true,
        actionType,
      });
      return;
    }

    if (actionType === "INVOICE") {
      setIsOpenModalInvoice(true);
      return;
    }

    if (actionType === "CANCEL_ORDER") {
      setIsOpenModalConfirm(true);
    }

    if (actionType === "GUESTS_INPUT") {
      setIsOpenModalGuestsInput(true);
    }
  };

  useEffect(() => {
    setGuestNo(idWiseGuestNumber[sessionId])
  }, [idWiseGuestNumber])

  return (
    <>
      <ActionModal
        open={open}
        setIsOpenModal={setIsOpenActionModal}
        onClickActionModalButton={handleModalButtonsAction}
      />
      <FloorPlanModal
        context={"ACTION_MODAL"}
        openModal={layoutModalParams.openModal}
        actionModalHandler={layoutModalActionHandler}
        onHandleCancel={onHandleCancelLayoutModal}
        addMoreTableHandler={() => {}}
      />
      <DisplayInvoice
        openModal={isOpenModalInvoice}
        records={{
          onCancel: handleCancelModalInvoice,
          param: { orderId: orderId },
        }}
      />

      <ConfirmModal
        isModalOpen={isOpenModalConfirm}
        centered
        records={{
          title: "Are you sure to decline the order?",
          handleOk: onHandleDeclineOrder,
          handleCancel: () => setIsOpenModalConfirm(false),
          confirmText: "Yes",
          cancelconfirmText: "No",
          customStyle: {
            top: 250,
          },
        }}
      />

      <CustomModal
        isCustomModalOpen={isOpenModalGuestsInput}
        onCancel={onCancelGuestsInput}
        onOk={updateGuests}
        title="Update Guest Number"
        subTitle=""
        okText="Update"
      >
        <div className="flex items center gap-2 mt-5 mb-10">
          <div className="font-ubold">Guest Number</div>
          <div className="flex-1">
            <CustomInputNumber
              name="guestNo"
              value={guestNo}
              setValue={setGuestNo}
              max={99}
              min={1}
              placeholder={"Guest number"}
            />
          </div>
        </div>
      </CustomModal>
    </>
  );
}
